// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import styled from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import StyledImg from '@ecp/common/src/components/image/StyledImg';

const Container = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.color.line.basic};
  z-index: 1200;
  position: fixed;
  top: ${({ appLinkBanner }) => appLinkBanner.height}px;

  transition: top 0.3s ease-in-out;
  left: auto;

  &.down,
  &.bottom {
    position: fixed;
    top: ${({ appLinkBanner }) => appLinkBanner.height - 46}px;
  }
`;

const Logo = styled(StyledImg)`
  height: 20px;
`;

export { Container, Logo };


